import React from "react";
import nordtech from "../assets/img/sponsors/nordtech.webp";
import amd from "../assets/img/sponsors/amd.webp";
import cadence from "../assets/img/sponsors/cadence.webp";
import marvell from "../assets/img/sponsors/marvell-logo.png";
import annapurnaLabs from "../assets/img/sponsors/annapurna-labs.png";
import sandia from "../assets/img/sponsors/sandia.webp";
import diode from "../assets/img/sponsors/diode.png";

function Sponsors() {
  return (
    <main id="main" className="sponsors-page">
      <section className="sponsors sponsors-showcase">
        <div className="container">
          <header className="sponsors-intro" data-aos="fade-up">
            <h1>Sponsors</h1>
            <p>
              C2S2 would not be possible without its sponsors. Through their
              generous contributions, they have enabled the team and its
              members to push the boundaries of what is possible at the
              undergraduate level for silicon and system design.
            </p>
          </header>

          <div className="sponsor-bar" data-aos="zoom-in" data-aos-delay="100">
            <a target="_blank" rel="noreferrer" href="https://nordtech.com">
              <img loading="lazy" decoding="async" src={nordtech} alt="NORDTECH" />
            </a>
            <a target="_blank" rel="noreferrer" href="https://amd.com">
              <img
                loading="lazy"
                decoding="async"
                className="sponsor-logo-wide"
                src={amd}
                alt="AMD"
              />
            </a>
            <a target="_blank" rel="noreferrer" href="https://sandia.gov/">
              <img
                loading="lazy"
                decoding="async"
                className="sponsor-logo-sandia"
                src={sandia}
                alt="Sandia National Laboratories"
              />
            </a>
            <a target="_blank" rel="noreferrer" href="https://www.cadence.com/">
              <img
                loading="lazy"
                decoding="async"
                className="sponsor-logo-wide"
                src={cadence}
                alt="Cadence"
              />
            </a>
            <a target="_blank" rel="noreferrer" href="https://www.marvell.com/">
              <img
                loading="lazy"
                decoding="async"
                className="sponsor-logo-wide"
                src={marvell}
                alt="Marvell"
              />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://amazon.jobs/content/en/teams/amazon-web-services/annapurna-labs"
            >
              <img
                loading="lazy"
                decoding="async"
                className="sponsor-logo-wide"
                src={annapurnaLabs}
                alt="Annapurna Labs"
              />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.diode.computer/"
            >
              <img
                loading="lazy"
                decoding="async"
                className="sponsor-logo-diode"
                src={diode}
                alt="Diode Computers"
              />
            </a>
          </div>
        </div>
      </section>

      <section className="services section-bg">
        <div className="container" data-aos="fade-up">
          <div className="section-title underline">
            <h1>Support C2S2</h1>
          </div>

          <div className="row">
            <div
              className="col-md-6 col-lg-6 col-sm-12 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="100"
            >
              <div className="icon-box">
                <div className="icon">
                  <i className="bx bx-donate-heart"></i>
                </div>
                <h4 className="title">Donate Now</h4>
                <p className="description">
                  C2S2 relies on donations to continuously fund our activities,
                  including chip fabrication, surrounding systems (such as
                  PCBs), and testing equipment. None of our accomplishments
                  would be possible without your donations
                </p>
                <a
                  target="_blank"
                  href="https://securelb.imodules.com/s/1717/giving/interior.aspx?sid=1717&gid=2&pgid=16421&cid=27217&dids=5432&sort=1&bledit=1"
                  className="application-btn"
                >
                  Donate
                </a>
              </div>
            </div>

            <div
              className="col-md-6 col-lg-6 col-sm-12 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="icon-box">
                <div className="icon">
                  <i className="bx bx-envelope"></i>
                </div>
                <h4 className="title">Reach Out</h4>
                <p className="description">
                  If you are interested in becoming a sponsor of C2S2, we'd love
                  to hear from you! To learn more, please contact us using the
                  link below. We are a charitable organization under section
                  501(c) (3), and all donations are tax-deductible
                </p>
                <a
                  target="_blank"
                  href="mailto:c2s2@cornell.edu?subject=Interested%20In%20A%20C2S2%20Sponsorship"
                  className="application-btn"
                >
                  Get In Contact!
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Sponsors;
